//= require jquery
//= require jquery_ujs
//= require jquery.number

//= require bootstrap
//= require bootstrap-dialog

//= require I18n
//= require i18n/translations

//= require flux-dispatcher
//= require events.module
//= require object-assign.module
//= require promise

//= require date
//= require DateHelper
//= require ObjectHelper
//= require classnames

//= require react-server
//= require react_ujs
//= require create-react-class
//= require clsx

//= require jquery.cookie

//= require numeral.min

//= require select2
//= require Selects/components/CurrencySelect
//= require FormattedInput

//= require bootstrap-input-spinner
//= require NumberSpinner
//= require GuestSelect
//= require cc_validate

//= require LoadingSpinner
//= require bootstrap-datepicker
//= require DatePicker
//= require Panel/components
//= require PromoCodeInput/components
//= require BookingProducts/components
//= require BookingFlow/components
//= require FlexibleDatePicker/components

$(function () {
  // tooltips

  $(document.body)
    .tooltip({
      selector:
        '[title]:not(iframe, .featherlight-previous, .featherlight-next, .cke_editable, .cke_button, .sp-clear, .sp-thumb-el, [data-tooltip="off"], [data-toggle="popover"], [class^="select2"])',
      delay: { show: 500, hide: 250 },
      container: "body",
      placement: function (tip, element) {
        var offset = $(element).offset();
        height = $(document).outerHeight();
        width = $(document).outerWidth();
        vert = 0.5 * height - offset.top;
        vertPlacement = vert > 0 ? "bottom" : "top";
        horiz = 0.5 * width - offset.left;
        horizPlacement = horiz > 0 ? "right" : "left";
        placement =
          Math.abs(horiz) > Math.abs(vert) ? horizPlacement : vertPlacement;
        return placement;
      },
      html: true,
    })
    .on("show.bs.tooltip", function (e) {
      $(".tooltip").not(e.target).tooltip("hide");
    });
});
